import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { OpportunitiesDataTable } from "./opportunities-data-table";

export default function OpportunityListView() {
  usePageTitle("Opportunity List");

  return (
    <ListPageLayout
      pageType="opportunities::list"
      title="Opportunity List"
      className="max-w-full"
    >
      <OpportunitiesDataTable />
    </ListPageLayout>
  );
}
